import "./PolicyList.css";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import ProductLogo from "../../ProductLogo";

const PolicyList = ({ RedirectTo, ReportClaim, onSendData, RedirectToEndorse, onLoading }) => {
    const [loadingPolicyList, setLoadingPolicyList] = useState(true);
    const [errorPolicyList, setErrorPolicyList] = useState(false);
    const [policyList, setPolicyList] = useState([]);
    const navigate = useNavigate();
    const getPolicyDetails = (policy) => {
        navigate(RedirectTo, { state: { policy } });
    };
    const getPolicyEndorse = (PolicyEndorse) => {
        navigate(RedirectToEndorse, { state: { PolicyEndorse } });
    };
    const token = localStorage.getItem("smc-csp-token");

    const GetPolicyList = async () => {
        try {
            onLoading(true); // Notify parent that loading has started
            const res = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/Api/Customers/GetPolicyList",
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.status === 200 && res.data.StatusCode === 200) {
                setPolicyList(res.data.Data.PolicyDetails);
                onSendData(res.data.Data.PolicyDetails);
            }
            setLoadingPolicyList(false);
        } catch (err) {
            setLoadingPolicyList(false);
            setErrorPolicyList(true);
        } finally {
            onLoading(false); // Notify parent that loading is done
        }
    };

    useEffect(() => {
        GetPolicyList();
    }, []);

    return (
        <>
            {loadingPolicyList && (
                <div className="ProductLoader">
                </div>
            )}
            {errorPolicyList && (
                <h6>
                    <i className="bi bi-patch-exclamation"></i> Error while loading policy list
                </h6>
            )}
            {policyList &&
                policyList.length > 0 &&
                policyList.map((item, index) => (
                    <div className="Policy-Card" key={index}>

                        <div className="col-1 text-center">
                            <ProductLogo item={item} />
                        </div>
                        <div className="col-2">
                            <p>End Date</p>
                            <span>{item.PolicyEndDate}</span>
                        </div>
                        <div className="col-3">
                            <p>Insurer</p>
                            <span>{item.InsurerName}</span>
                        </div>
                        <div className="col-3">
                            <div className="ActionBTN">
                                {ReportClaim && (
                                    <a onClick={() => ReportClaim(item)}>Report Claim</a>
                                )}
                                {RedirectTo &&
                                    <a onClick={(e) => getPolicyDetails(item)}>
                                        View Details
                                    </a>
                                }
                                {RedirectToEndorse &&
                                    <a onClick={(e) => getPolicyEndorse(item)}>
                                        Endorsements
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                ))}
        </>
    );
};
export default PolicyList;
